import { Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { AuthGuard } from './guard/auth.guard';
import { GlobalContants, PageTitle } from './constants/global.contants';
// import { DashboardComponent } from './pages/components/dashboard/dashboard.component';
import { GenerateApiKeyComponent } from './pages/components/generate-api-key/generate-api-key.component';
import { ProfileComponent } from './pages/components/profile/profile.component';
import { ChangePasswordComponent } from './pages/components/change-password/change-password.component';
import { AuthenticationComponent } from './pages/components/api-authentication/authentication.component';
import { NearbyGroupComponent } from './pages/components/api-nearby/nearby-group.component';

import { CommercialDataComponent } from './pages/components/commercial-data/commercial-data.component';
import { AvmRentalComponent } from './pages/components/avm-rental/avm-rental.component';
import { CommercialRentalComponent } from './pages/components/commercial-rental/commercial-rental.component';
import { ApartmentSaleAvmComponent } from './pages/components/apartment-sale-avm/apartment-sale-avm.component';
import { AvmDataComponent } from './pages/components/api-data/avm-data.component';
import { DallalBuildingsComponent } from './pages/components/dallal-buildings/dallal-buildings.component';
import { DallalFloorComponent } from './pages/components/dallal-floor/dallal-floor.component';
import { DallalUnitComponent } from './pages/components/dallal-unit/dallal-unit.component';
import { DallalTransactionComponent } from './pages/components/dallal-transaction/dallal-transaction.component';
import { AvmApiComponent } from './pages/components/avm/avm-api.component';
import { NearbyDataComponent } from './pages/components/nearby-data/nearby-data.component';
import { AvmCalculatorComponent } from './pages/components/avm-calculator/avm-calculator.component';
export const routes: Routes = [
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: '',
        redirectTo: '/authentication',
        pathMatch: 'full',
      },
      {
        path: 'authentication',
        loadChildren: () =>
          import('./pages/authentication/authentication.routes').then(
            (m) => m.AuthenticationRoutes
          ),
      },
    ],
  },
  {
    path: 'home',
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: GlobalContants.Routes.GenerateApiKey,
        pathMatch: 'full',
      },
      // {
      //   path: GlobalContants.Routes.Dashboard,
      //   component: DashboardComponent,
      //   title: PageTitle.dashboard
      // },
      {
        path: GlobalContants.Routes.GenerateApiKey,
        component: GenerateApiKeyComponent,
        title: PageTitle.generateApiKey
      },
      {
        path: GlobalContants.Routes.Profile,
        component: ProfileComponent,
        title: PageTitle.profile
      },
      {
        path: GlobalContants.Routes.ChangePassword,
        component: ChangePasswordComponent,
        title: PageTitle.changePassword
      },
      {
        path: GlobalContants.Routes.AvmGgroup,
        component: AvmDataComponent,
        title: PageTitle.avmGroup
      },
        {
        path: GlobalContants.Routes.nearbbyApi,
        component: NearbyDataComponent,
        title: PageTitle.nearbyApi
      },
      {
        path: GlobalContants.Routes.NearbyGroup,
        component: NearbyGroupComponent,
        title: PageTitle.nearbyGroup
      },
      {
        path: GlobalContants.Routes.AvmRental,
        component: AvmRentalComponent,
        title: PageTitle.avmRental
      },
      {
        path: GlobalContants.Routes.CommercialData,
        component: CommercialDataComponent,
        title: PageTitle.commercialData
      },
      {
        path: GlobalContants.Routes.AuthenticationAPI,
        component: AuthenticationComponent,
        title: PageTitle.authenticationApi
      },
      {
        path: GlobalContants.Routes.CommercialRental,
        component: CommercialRentalComponent,
        title: PageTitle.commercialRental
      },
      {
        path: GlobalContants.Routes.ApartmentSaleAVM,
        component: ApartmentSaleAvmComponent,
        title: PageTitle.apartmentSaleAVM
      },
       {
        path: GlobalContants.Routes.AvmApi,
        component: AvmApiComponent,
        title: PageTitle.avmApi
      },
      {
        path: GlobalContants.Routes.Buildings,
        component: DallalBuildingsComponent,
        title: PageTitle.buildings
      },
      {
        path: GlobalContants.Routes.Floor,
        component: DallalFloorComponent,
        title: PageTitle.floor
      },
      {
        path: GlobalContants.Routes.Unit,
        component: DallalUnitComponent,
        title: PageTitle.unit
      },
      {
        path: GlobalContants.Routes.Transaction,
        component: DallalTransactionComponent,
        title: PageTitle.transaction
      },
      {
        path: GlobalContants.Routes.avmCalculator,
        component: AvmCalculatorComponent,
        title: PageTitle.avmCalculator
      },
    ],
    canActivate: [AuthGuard]
  },
  {
    path: '**',
    redirectTo: '/',
  },
];
